import { render, staticRenderFns } from "./vips.vue?vue&type=template&id=77dda12f&"
import script from "./vips.vue?vue&type=script&lang=js&"
export * from "./vips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports